import { IntlContextConsumer, changeLocale } from 'gatsby-plugin-intl';
import React from 'react';

const Language = () => {
  return (
    <ul className='lang-icon-list'>
      <IntlContextConsumer>
        {({ languages, language: currentLocale }) =>
          languages.map(language => (
            <li key={language}>
              <button
                className={language===currentLocale ? 'active' : ''}
                style={{ display: 'inline-flex', background: 'transparent' }}
                key={language}
                onClick={() => changeLocale(language)}
              >
                {language === 'en' ? (
                  <span className='en'>EN</span>
                ) : (
                  <span className='de'>DE</span>
                )}
              </button>
            </li>
          ))
        }
      </IntlContextConsumer>
    </ul>
  );
};

export default Language;
